
import { supabase } from "@/integrations/supabase/client";
import { MembershipApplication } from "@/components/admin/membership/types";
import { toast } from "@/hooks/use-toast";

export const downloadApplicationPDF = async (application: MembershipApplication) => {
  try {
    console.log("[AdminMembershipApplications] Generating PDF for:", application.business_name);
    
    if (!application || !application.id) {
      throw new Error("Invalid application data");
    }
    
    // Call the Edge Function to generate the PDF
    const { data, error } = await supabase.functions.invoke("generate-membership-pdf", {
      body: { application },
    });

    if (error) {
      console.error("[AdminMembershipApplications] PDF generation error:", error);
      throw new Error(`PDF generation failed: ${error.message || "Unknown error"}`);
    }

    if (!data || !data.pdf) {
      console.error("[AdminMembershipApplications] No PDF data received:", data);
      throw new Error("No PDF data received from the server");
    }

    // Create binary data from the base64 response
    try {
      const byteCharacters = atob(data.pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      
      // Create a download link and trigger it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `spo-membership-${application.business_name.toLowerCase().replace(/\s+/g, '-')}.pdf`;
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast({
        title: "PDF Downloaded",
        description: `PDF for ${application.business_name} has been downloaded successfully.`,
      });
    } catch (blobError) {
      console.error("[AdminMembershipApplications] Error creating PDF blob:", blobError);
      throw new Error("Failed to convert PDF data to a downloadable file");
    }
  } catch (error) {
    console.error("[AdminMembershipApplications] PDF generation error:", error);
    toast({
      title: "Error Downloading PDF",
      description: error.message || "There was an error generating the PDF. Please try again.",
      variant: "destructive",
    });
  }
};
